import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from '../login/login.guard';
import { NotFoundComponent } from '../not-found/not-found.component';
import { PrivateAreaComponent } from './private-area.component';

const routes: Routes = [
  {
    path: '',
    component: PrivateAreaComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'duplicate-registration',
        loadChildren: () => import('../duplicate-registration/duplicate-registration.module').then(m => m.DuplicateRegistrationModule)
      },
      {
        path: 'inactive-users',
        loadChildren: () => import('../inactive-users/inactive-users.module').then(m => m.InactiveUsersModule)
      },
      {
        path: 'how-to',
        loadChildren: () => import('../how-to-use/how-to-use.module').then(m => m.HowToUseModule)
      },
      {
        path: 'roles',
        loadChildren: () => import('../roles/roles.module').then(m => m.RolesModule)
      },
      {
        path: 'permissions',
        loadChildren: () => import('../permissions/permissions.module').then(m => m.PermissionsModule)
      },
      {
        path: 'users',
        loadChildren: () => import('../users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'events',
        loadChildren: () => import('../events/events.module').then(m => m.EventsModule)
      },
      {
        path: 'user-cancellation',
        loadChildren: () => import('../user-cancellation/user-cancellation.module').then(m => m.UserCancellationModule)
      },
      {
        path: 'user-addition',
        loadChildren: () => import('../user-addition/user-addition.module').then(m => m.UserAdditionModule)
      },
      {
        path: 'force-password',
        loadChildren: () => import('../force-password/force-password.module').then(m => m.ForcePasswordModule)
      },
      {
        path: 'reviews',
        loadChildren: () => import('../reviews/reviews.module').then(m => m.ReviewsModule)
      },
      {
        path: 'user-extraction',
        loadChildren: () => import('../user-extraction/user-extraction.module').then(m => m.UserExtractionModule)
      },
      {
        path: 'association-contract',
        loadChildren: () => import('../association-contract/association-contract.module').then(m => m.AssociationContractModule)
      },
      {
        path: 'search-customers',
        loadChildren: () => import('../search-customers/search-customers.module').then(m => m.SearchCustomersModule)
      },
      {
        path: 'search-association',
        loadChildren: () => import('../search-association/search-association.module').then(m => m.SearchAssociationModule)
      },
      {
        path: 'informativa-privacy',
        loadChildren: () => import('../informativa-privacy/informativa-privacy.module').then(m => m.InformativaPrivacyModule)
      },
      {
        path: 'aging-fatture',
        loadChildren: () => import('../aging-fatture/aging-fatture.module').then(m => m.AgingFattureModule)
      },
      {
        path: 'ricerca-utenti-fb',
        loadChildren: () => import('../ricerca-utenti-fb/ricerca-utenti-fb.module').then(m => m.RicercaUtentiFbModule)
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivateAreaRoutingModule {}
